import React from 'react';
import { Crown, Instagram, Phone } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black pt-16 pb-8 border-t border-white/5" data-id="element-75">
      <div className="container mx-auto px-6" data-id="element-76">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-10 mb-12" data-id="element-77">
          <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-78">
            <div className="flex items-center gap-3 mb-4" data-id="element-79">
              <Crown className="text-gold w-8 h-8" data-id="element-80" />
              <span className="font-serif text-2xl font-bold tracking-wider" data-id="element-81">
                PRINCE
              </span>
            </div>
            <p className="text-gray-400 text-sm max-w-xs" data-id="element-82">
              QUE TU ESTILO HABLE POR TI. Viví la experiencia de sentirte un
              Prince.
            </p>
          </div>

          <div className="flex gap-8 text-sm font-medium text-gray-400" data-id="element-83">
            <a href="#servicios" className="hover:text-gold transition-colors" data-id="element-84">
              Servicios
            </a>
            <a href="#cursos" className="hover:text-gold transition-colors" data-id="element-85">
              Cursos
            </a>
            <a href="#galeria" className="hover:text-gold transition-colors" data-id="element-86">
              Galería
            </a>
            <a href="#contacto" className="hover:text-gold transition-colors" data-id="element-87">
              Contacto
            </a>
          </div>

          <div className="flex gap-4" data-id="element-88">
            <a href="https://instagram.com/princebarberstudio" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-dark-surface flex items-center justify-center text-gray-400 hover:text-gold hover:bg-white/5 transition-all" data-id="element-89">
              <Instagram size={18} data-id="element-90" />
            </a>
            <a href="tel:091414192" className="w-10 h-10 rounded-full bg-dark-surface flex items-center justify-center text-gray-400 hover:text-gold hover:bg-white/5 transition-all" data-id="element-91">
              <Phone size={18} data-id="element-92" />
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center text-xs text-gray-600" data-id="element-93">
          <p data-id="element-94">
            © {new Date().getFullYear()} Prince Barber Studio. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}